import visionProOutline from '@/assets/device-icons/vision-pro-outline.svg';

interface VisionProOutlineIconProps {
  className?: string;
}

export const VisionProOutlineIcon = ({ className = "h-5 w-5" }: VisionProOutlineIconProps) => {
  return (
    <img 
      src={visionProOutline} 
      alt="Vision Pro" 
      className={className}
    />
  );
};
